import React, { useEffect, useState } from "react";
import "../../Completed/QuestionCompleted/QuestionType.css";
import CheckBoxType from "./CheckBoxType";
import SucessfullySubmited from "./SucessfullySubmited";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";

export default function AllQuestions({ type, handleQuestionfalse }) {
  const { homeworkId, selfAssessmentId } = useParams();
  const { state } = useLocation()
  const [studentResult, setStudentResult] = useState();
  const [resultData, setResultData] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const navigate = useNavigate();

  const getHWQuestionResponse = async () => {
    try {
      let res = await axios.get(
        `/homework/${state.homeworkId}/studentResult/student/${userId}/get`
      );
      res && setStudentResult(res.data.data);
      setIsGettingData(false);
      setResultData(res?.data?.data?.results);
    } catch (error) {
      setIsGettingData(false);
      console.log(error);
    }
  };

  const getSAQuestionResponse = async () => {
    try {
      let res = await axios.get(
        `/selfAssess/${state.selfAssessmentId}/studentResult/student/${userId}/get`
      );
      res && setStudentResult(res.data.data);
      setIsGettingData(false);
      setResultData(res?.data?.data?.results);
    } catch (error) {
      setIsGettingData(false);
      console.log(error);
    }
  };

  useEffect(() => {

    if (type == "SA") {
      getSAQuestionResponse();
    } else {
      getHWQuestionResponse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [questionNo, setQuestionNo] = useState(0);
  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleSucessfulyfalse = () => {
    setAllQuestion({
      ...allQuestion,
      sucessful: false,
    });
  };

  const getClassName = (element) => {
    return element.answer
      ? element.answer.key.trim() === ""
        ? "QuestionNoNonActive"
        : "QuestionActiveNo"
      : element?.descriptive_answer?.trim() === ""
        ? "QuestionNoNonActive"
        : "QuestionActiveNo";
  };
  console.log("studentResult : ", studentResult)
  return (
    <>
      {studentResult ? (
        <div className="d-flex gap-1">
          <div>
            <img
              style={{ cursor: "pointer" }}
              onClick={() => type == "SA" ? navigate("/SelfAssessment") : navigate("/Homework")}
              src="/HwImg/backArrow.png"
              alt=""
            />{" "}
            &nbsp;
          </div>
          <div className="hederContainer1">
            <div>
              <div className="d-flex justify-content-between w-100  ">
                <div>
                  <span className="quesHeading">
                    {type == "SA" ? studentResult?.selfAssess?.name : studentResult?.homework?.name}
                  </span>
                </div>
                <div>
                  <div style={{ textAlign: "right" }}>
                    <span className="subTitles">Total Marks Obtained</span>{" "}
                    &nbsp;
                    <span className="quesHeading">
                      {studentResult?.obtained_marks}/
                      {type == "SA" ? studentResult?.selfAssess?.total_marks : studentResult?.homework?.total_marks}
                    </span>
                  </div>
                  <div>
                    &nbsp;{" "}
                    <span className="subTitles">This Question Obtained</span>{" "}
                    &nbsp;
                    <span className="quesHeading">
                      {resultData[questionNo]?.obtained_marks}/
                      {resultData[questionNo]?.question_response?.question?.correct_score ?? resultData[questionNo]?.question_response?.b4sQuestion?.correct_score}
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100 mt-1">
                <div className="d-flex">
                  <div>
                    <span className="subTitle2">
                      {type == "SA" ? studentResult?.selfAssess?.subject_id?.name : studentResult?.homework?.subject_id?.name}
                    </span>
                    &nbsp;
                    {
                      type == "SA" ? null :
                        <><span>|</span> &nbsp;
                          <span className="subTitles3">Deadline</span> &nbsp;
                          <span className="subTitle2">
                            {timeHelper(studentResult?.homework?.deadline)}
                          </span>
                          &nbsp;
                        </>
                    }

                  </div>
                  <div>
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Submitted</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(studentResult?.submitted_on)}
                    </span>
                    &nbsp;
                  </div>
                  <div>
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Evaluated on</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(studentResult?.evaluation_on)}
                    </span>
                    &nbsp;
                  </div>
                </div>
                <div className="subTitle2">
                  Questions: {questionNo + 1}/{resultData?.length}
                </div>
              </div>
            </div>
            <div style={{ fontSize: "18px", fontWeight: "500", margin: "15px 0px" }}>{studentResult?.homework?.description}</div>
            <div className="mt-3 d-flex gap-2">
              {resultData?.length > 0 &&
                resultData?.map((item, index) => (
                  <div
                    onClick={(e) => setQuestionNo(index)}
                    className={getClassName(item)}
                    style={{
                      borderColor: item.answer
                        ? item.answer.key.trim() === ""
                          ? "#668598"
                          : "#F77F00"
                        : item?.descriptive_answer?.trim() === ""
                          ? "#668598"
                          : "#F77F00",
                      color:
                        item.answer
                          ? item.answer.key.trim() === ""
                            ? "#668598"
                            : "#F77F00"
                          : item?.descriptive_answer?.trim() === ""
                            ? "#668598"
                            : "#F77F00",
                      backgroundColor:
                        item.answer
                          ? item.answer.key.trim() === ""
                            ? "transparent"
                            : "#FEF2E5"
                          : item?.descriptive_answer?.trim() === ""
                            ? "transparent"
                            : "#FEF2E5",
                    }}
                  >
                    Q{index + 1}
                  </div>
                ))}
            </div>

            <div className="mt-4 allquestionTypesContainer">
              {!resultData[questionNo]?.question_response?.question?.type
                ?.is_manually_graded ? (
                <CheckBoxType
                  type={type}
                  questionNo={questionNo + 1}
                  response={resultData[questionNo]}
                />
              ) : (
                <SubmisshionByUpload
                  questionNo={questionNo + 1}
                  response={resultData[questionNo]}
                />
              )}

              <div className="d-flex gap-2 justify-content-end">
                {questionNo >= 1 && (
                  <button
                    className="PreviousBtnQue"
                    onClick={(e) => setQuestionNo(questionNo - 1)}
                  >
                    Previous
                  </button>
                )}

                {resultData?.length > questionNo + 1 && (
                  <button
                    className="nextBtnQue"
                    onClick={(e) => setQuestionNo(questionNo + 1)}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          </div>

          {allQuestion.sucessful && (
            <SucessfullySubmited
              handleSucessfulyfalse={handleSucessfulyfalse}
            />
          )}
        </div>
      ) : isGettingData ? (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <img
            className="ongoing_internal_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <span>{type == "SA" ? "Self Assessment " : "Homework "} Not Found</span>
        </div>
      )}
    </>
  );
}
